/**
 * Turn a Supabase Auth error into copy we are willing to show a user.
 *
 * Both sign-in screens used to fall through to `setError(signInError)` for
 * anything that wasn't an "Invalid credentials" error, which put raw backend
 * strings on screen — an unverified account was told, literally, "Email not
 * confirmed".
 *
 * That also made the screens' own unverified-email branch dead code: it was
 * written as `if (!signedInUser.email_confirmed_at)`, but Supabase never
 * returns a user for an unconfirmed account. It returns an error, so control
 * never reached that branch.
 */
export const friendlyAuthError = (rawMessage) => {
    const msg = String(rawMessage || '');
    const lower = msg.toLowerCase();

    if (lower.includes('email not confirmed') || lower.includes('not confirmed')) {
        return 'Please verify your email address before signing in. Check your inbox for the verification link.';
    }
    if (lower.includes('invalid login') || lower.includes('invalid credentials') || lower.includes('invalid')) {
        return 'The email or password you entered is incorrect. Please try again.';
    }
    if (lower.includes('rate limit') || lower.includes('too many')) {
        return 'Too many attempts. Please wait a moment and try again.';
    }
    if (lower.includes('network') || lower.includes('fetch')) {
        return 'We could not reach Sigma Bank. Check your connection and try again.';
    }

    // Anything unrecognised: log the real reason for support, show a generic
    // message rather than leaking backend wording.
    if (msg) console.error('Auth error:', msg);
    return 'We could not sign you in. Please try again, or contact support if this continues.';
};
